<template>
  <div class="page-header-wrapper">
    <div class="breadcrumb">
      <a-page-header :title="currentRouteTitle" :breadcrumb="{ props: { routes: breadcrumbs } }">
        <template slot="extra" v-if="showBack">
          <a-button size="small" shape="round" style="margin: 4px 0" @click="handleGoBack"> 返回 </a-button>
        </template>
      </a-page-header>
    </div>
    <div class="wrapper-container">
      <slot />
    </div>
  </div>
</template>




<script>
export default {
  mounted() {
    console.log(this.$route.matched)
  },
  //返回跳转
  methods:{
    handleGoBack(){
      this.$router.push(`/outcome/technology`)
      this.$route.push(`/src/views/outcome/catalog/components/SubmitList/index.vue`)
    }
  },
  props: {
    showBack: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    breadcrumbs() {
      return this.$route.matched.map((item) => ({
        path: item.path,
        breadcrumbName: item.meta.title,
      }))
    },
    currentRouteTitle() {
      return this.$route.meta.title
    },
  },
}
</script>

<style lang="less" scoped>
.page-header-wrapper {
  margin: -12px;
  .breadcrumb {
    background: #fff;
    padding: 0 30px;
  }
}
.wrapper-container {
  min-width: 1200px;
  margin: 0 50px;
}
</style>